/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CancelFilled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM7.01665 8.18337L10.8333 12L7.01665 15.8166L8.18338 16.9834L12 13.1667L15.8166 16.9834L16.9834 15.8166L13.1667 12L16.9834 8.18337L15.8167 7.01665L12 10.8333L8.18337 7.01665L7.01665 8.18337Z"
                        fill={color}
                    />
                </svg>
        );
    };
